/**
 * Api errors that can be reported by the Order controller
 */
export var OrderErrorCode;
(function (OrderErrorCode) {
    /**
     * A payment failed due to a credit card error.
     */
    OrderErrorCode["PaymentFailedCardError"] = "order/PaymentFailedCardError";
    /**
     * A generic payment failed error.
     */
    OrderErrorCode["PaymentFailedError"] = "order/PaymentFailedError";
    /**
     * An attempt was made to modify an order that was not in a modifiable state
     */
    OrderErrorCode["CannotModifyOrder"] = "order/CannotModifyOrder";
    /**
     * An attempt was made to modify/create an order with a turnaround
     * that does not exist.
     */
    OrderErrorCode["OrderTurnaroundNotFound"] = "order/OrderTurnaroundNotFound";
    /**
     * The order could not be placed because the court system requires that orders of that line item type
     * are submitted with supporting documents attached.
     */
    OrderErrorCode["RequiredSupportingDocumentsNotAttached"] = "order/RequiredSupportingDocumentsNotAttached";
    /**
     * The order could not be placed because cost waivers must be enabled when requesting a cost waiver.
     */
    OrderErrorCode["CostWaiverDisabled"] = "order/CostWaiverDisabled";
    /**
     * The order could not be placed because cost waiver documents must be attached when requesting a cost waiver.
     */
    OrderErrorCode["RequiredCostWaiverDocumentsNotAttached"] = "order/RequiredCostWaiverDocumentsNotAttached";
    /**
     * An attempt was made to update the order's claim with stale data.
     */
    OrderErrorCode["CannotUpdateClaimOnStaleOrder"] = "order/CannotUpdateClaimOnStaleOrder";
    /**
     * The user placing this order is not allowed to distribute transcripts
     */
    OrderErrorCode["UserNotAllowedToDistributeTranscripts"] = "order/UserNotAllowedToDistributeTranscripts";
    /**
     * There are too many emails in this order's distribution list
     */
    OrderErrorCode["TooManyDistributionEmails"] = "order/TooManyDistributionEmails";
    /**
     * There is a duplicate email address in this order's distribution list
     */
    OrderErrorCode["DuplicateEmailInDistributionList"] = "order/DuplicateEmailInDistributionList";
    /**
     * There is an invalid email in this order's distribution list
     */
    OrderErrorCode["InvalidEmailInDistributionList"] = "order/InvalidEmailInDistributionList";
    /**
     * The user placing this order is in the order's distribution list
     */
    OrderErrorCode["UserInDistributionList"] = "order/UserInDistributionList";
    /**
     * The PlaceOrderGroupRequest contract has been validated and is invalid.
     */
    OrderErrorCode["InvalidOrderPlacement"] = "order/InvalidOrderPlacement";
    /**
     * The ResubmitOrderRequest contract has been validated and is invalid.
     */
    OrderErrorCode["InvalidOrderResubmission"] = "order/InvalidOrderResubmission";
    /**
     * User who placed this order is no longer allowed to distribute transcripts in this court system
     */
    OrderErrorCode["UserDistributionPermissionRevoked"] = "order/UserDistributionPermissionRevoked";
    /**
     * The feature is disabled for this court system
     */
    OrderErrorCode["CannotAccessDisabledFeature"] = "order/CannotAccessDisabledFeature";
    /**
     * Cannot cancel order in this state, rather than throwing an Unknown Error Occurred to the user.
     */
    OrderErrorCode["CannotCancelOrder"] = "order/CannotCancelOrder";
    /**
     * Expected audio segment for order to have recordingId.
     */
    OrderErrorCode["AudioSegmentMissingRecordingId"] = "order/AudioSegmentMissingRecordingId";
    /**
     * Expected audio segment for order to have timecodes.
     */
    OrderErrorCode["AudioSegmentMissingTimecodes"] = "order/AudioSegmentMissingTimecodes";
    /**
     * Expected audio segment for order to be live.
     */
    OrderErrorCode["AudioSegmentNotLive"] = "order/AudioSegmentNotLive";
    /**
     * Expected different line item type.
     */
    OrderErrorCode["UnexpectedLineItemType"] = "order/UnexpectedLineItemType";
    /**
     * Expected different order status.
     */
    OrderErrorCode["UnexpectedOrderStatus"] = "order/UnexpectedOrderStatus";
    /**
     * Active recording was missing for a real-time order.
     */
    OrderErrorCode["MissingActiveRecordingForRealTimeOrder"] = "order/MissingActiveRecordingForRealTimeOrder";
    /**
     * The recording id on the audio segment did not match the live recording.
     */
    OrderErrorCode["InvalidAudioSegmentRecordingId"] = "order/InvalidAudioSegmentRecordingId";
    /**
     * The timecodes on the rejoined order would have overlapped, try again later.
     */
    OrderErrorCode["OverlappingTimecodesOnLiveAudioSegment"] = "order/OverlappingTimecodesOnLiveAudioSegment";
    /**
     * A RealTime order shouldn't be rejoined because user has no saved payment methods
     */
    OrderErrorCode["UserHasNoPaymentMethods"] = "order/UserHasNoPaymentMethods";
})(OrderErrorCode || (OrderErrorCode = {}));
